var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdfPage',{attrs:{"node":_vm.node}},[_c('KeyFinanceRatio',{attrs:{"mode":"pdf","node":_vm.node}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }